export default __webpack_public_path__ + "static/media/task.746ca130.svg";